var _defs, _rect, _rect2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagPortugal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".portugalb{fill:red;}.portugalc{fill:#060;}.portugald{fill:#ff0;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "portugalb",
    width: 100,
    height: 60
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "portugalc",
    width: 38.75,
    height: 60
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "portugald",
    cx: 38.75,
    cy: 30,
    r: 14.58
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPortugal);
export default __webpack_public_path__ + "static/media/FlagPortugal.c4bb88af8a9fc2b13845aa3364b190c6.svg";
export { ForwardRef as ReactComponent };